import styled from 'styled-components';

// Shared pill-button + popover styling for the agents-liveboard header controls
// (Filter and Sort), so the two controls read as one consistent control group.

// `position: relative; z-index: 1` traps the absolutely-positioned Panel in a
// local stacking context below the top bar ($topBar-zIndex: 7), so an open
// popover never paints over the top bar or phone controls.
export const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  z-index: 1;
`;

export const PillButton = styled.button`
  align-items: center;
  background: ${p => (p.active ? p.theme.colors.green400 : p.theme.colors.white)};
  border: 1px solid ${p => (p.active ? p.theme.colors.green400 : p.theme.colors.gray400)};
  border-radius: 16px;
  color: ${p => (p.active ? p.theme.colors.white : p.theme.colors.gray800)};
  cursor: pointer;
  display: flex;
  font-size: ${p => p.theme.fontSize.small};
  font-weight: ${p => p.theme.fontWeight.medium};
  gap: 6px;
  padding: 4px 12px;
  white-space: nowrap;
`;

export const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: ${p => p.theme.colors.gray600};
  cursor: pointer;
  font-size: ${p => p.theme.fontSize.small};
  margin-left: 4px;
  padding: 4px 8px;
`;

export const Panel = styled.div`
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  border-radius: 8px;
  box-shadow: ${p => p.theme.boxShadow.medium};
  margin-top: 6px;
  min-width: 200px;
  padding: 12px 16px;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 1;
`;

export const PanelSection = styled.div`
  & + & {
    border-top: 1px solid ${p => p.theme.colors.gray200};
    margin-top: 12px;
    padding-top: 12px;
  }
`;

export const PanelSectionTitle = styled.div`
  color: ${p => p.theme.colors.gray600};
  font-size: ${p => p.theme.fontSize.small};
  font-weight: ${p => p.theme.fontWeight.medium};
  margin-bottom: 8px;
  text-transform: uppercase;
`;

export const PanelRow = styled.div`
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PanelFooter = styled.div`
  border-top: 1px solid ${p => p.theme.colors.gray200};
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 8px;
`;

// Menu panel for the single-select Sort popover. Matches the header
// report-filter dropdowns (Org Time / Teams / Inboxes): options run edge to
// edge and provide their own padding, so the panel itself is flush.
export const MenuPanel = styled(Panel)`
  padding: 4px 0;
`;

// Single-select option row for the Sort popover, styled to match the
// report-filter dropdown options: 8px 10px padding, inherited 13px text, and a
// brand-green highlight with white text when selected or hovered.
export const OptionButton = styled.button`
  background: ${p => (p.selected ? p.theme.colors.green400 : 'transparent')};
  border: none;
  color: ${p => (p.selected ? p.theme.colors.white : 'inherit')};
  cursor: pointer;
  display: block;
  font: inherit;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
  width: 100%;

  &:hover {
    background: ${p => p.theme.colors.green400};
    color: ${p => p.theme.colors.white};
  }
`;
